import type { MapImageConfigInterface } from '@/map-phaser-new/interfaces'

export const mapImageConfig: MapImageConfigInterface = {
  textureKey: 'map',
  mapOverlaysConfig: [
    {
      textureKey: 'main-overlay-ships',
      depth: 1,
    },
    {
      textureKey: 'main-overlay-cars',
      depth: 3,
    },
  ],
}
